<gp-privacy-banner
    geoAppName="geobus"
    [pathOfImpressum]="pathOfImpressum"
    pathOfUsageConditions="/services/file/Nutzungsbedingungen.pdf"
></gp-privacy-banner>
<ui-view></ui-view>
